export function serializeUrlParams(data = {}, isPrefix = true, arrayFormat = 'brackets') {
  let prefix = isPrefix ? '?' : ''
  let _result = []
  if (['indices', 'brackets', 'repeat', 'comma'].indexOf('arrayFormat') === -1) arrayFormat = 'brackets'
  for (let key in data) {
    let value = data[key]
    if (['', undefined, null].indexOf(value) >= 0) continue
    if (value.constructor === Array) {
      switch (arrayFormat) {
        //e.g. {ids: [1,2,3]}
        case 'indices':
          for (let i = 0; i < value.length; i++) {
            _result.push(key + '[' + i + ']=' + value[i])
          }
          break
        case 'brackets':
          // result: ids[]=1&ids[]=2&ids[]=3
          value.forEach(_value => {
            _result.push(key + '[]=' + _value)
          })
          break
        case 'repeat':
          //结果: ids=1&ids=2&ids=3
          value.forEach(_value => {
            _result.push(key + '=' + _value)
          })
          break
        case 'comma':
          //result ids=1,2,3
          var commaStr = ''
          value.forEach(_value => {
            commaStr += (commaStr ? ',' : '') + _value
          })
          _result.push(key + '=' + commaStr)
          break
        default:
          value.forEach(_value => {
            _result.push(key + '[]=' + _value)
          })
      }
    } else {
      _result.push(key + '=' + value)
    }
  }
  return _result.length ? prefix + _result.join('&') : ''
}

/**
 * 解析URL中的参数
 * @param {String} url url地址，默认值：weex.config.bundleUrl
 * @return {Object}
 */
export function parseUrlParams(url) {
  const params = {}
  if (!url) url = weex.config.bundleUrl
  const index = url.indexOf('?')
  if (index > 0) {
    const query = url.substring(index + 1)
    const temp = query.split('&')
    let key, value
    for (var p in temp) {
      if (temp[p]) {
        key = temp[p].split('=')[0]
        value = temp[p].split('=')[1]
        params[key] = decodeURIComponent(value)
      }
    }
  }
  return params
}



// WEBPACK FOOTER //
// ./packages/utils/urlParams.js